import React from "react";
import { Box, Typography, TypographyTypeMap, useTheme } from "@mui/material";

export interface AIGradientTextProps {
  children: React.ReactNode;
  variant?: TypographyTypeMap["props"]["variant"];
  onClick?: () => void;
}

export default function AIGradientText(props: AIGradientTextProps) {
  const theme = useTheme();

  return (
    <Typography
      variant={props.variant || "h3"}
      sx={{
        animation: 'ai-text 4s linear infinite',
        background: theme.colors.namedColors.aiGradient,
        backgroundSize: "200% auto",
        backgroundClip: "text",
        textFillColor: "transparent",
        "@keyframes ai-text": {
          "0%": { backgroundPosition: "0% 0%" },
          "50%": { backgroundPosition: "100% 100%" },
          "100%": { backgroundPosition: "0% 0%" },
        }
      }}
      onClick={props.onClick}
      >

      {props.children}
    </Typography>
  );
}